import type { Props } from './types';

import { styled } from 'styled-components';

import DesktopNav from './DesktopNav';
import MobileNav from './MobileNav';

const StepHeaderSC = styled.div`
  width: 100%;
  height: 2.5rem;
  padding: 0.375rem 1rem;
  background-color: ${(props) => props.theme.colors.oxfordBlue[100]};
  color: ${(props) => props.theme.colors.white};
  border-top: 1px solid ${(props) => props.theme.colors.oxfordBlue[80]};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.875rem;
  line-height: 1.75rem;
  position: sticky;
  top: 0;
  z-index: 2;

  @media (min-width: ${(props) => props.theme.devices.tablet}) {
    height: ${(props) => props.theme.dimensions.stepHeaderHeight};
  }
`;

export const StepHeader = (props: Props) => {
  return (
    <StepHeaderSC>
      <MobileNav {...props} />
      <DesktopNav {...props} />
    </StepHeaderSC>
  );
};
